

























































import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';
import Nullable from '@/types/nullable';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Take5Think extends Vue {
  @Prop({ type: Object, default: null }) public take5!: Nullable<JobTake5Check>;

  private expanded: boolean = false;

  private fit: boolean | null = null;

  textRequired(v: string) {
    if (v == null || v.length == 0) {
      return "Cannot be left blank";
    }

    return true;
  }
}

